import { useState } from "react";
import {
    Alert, Box, Button, Card, FormControl, FormLabel, IconButton, Input, Stack,
    Typography, Divider,
} from "@mui/joy";

import LockRoundedIcon from '@mui/icons-material/LockRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

import { usePartner } from "../../PartnerContext";
import { APIPartnerChangePassword } from "../../api_partner_auth";


export default function PartnerSecurity() {
    const { partnerToken } = usePartner();

    const [oldPw, setOldPw] = useState('');
    const [newPw, setNewPw] = useState('');
    const [newPw2, setNewPw2] = useState('');
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState(null);

    const submit = async () => {
        setMsg(null);
        if (newPw.length < 8) {
            setMsg({ color: 'danger', text: 'Новый пароль не короче 8 символов' });
            return;
        }
        if (newPw !== newPw2) {
            setMsg({ color: 'danger', text: 'Новые пароли не совпадают' });
            return;
        }
        try {
            setLoading(true);
            await APIPartnerChangePassword(partnerToken, {
                old_password: oldPw,
                new_password: newPw,
            });
            setMsg({ color: 'success', text: 'Пароль изменён' });
            setOldPw(''); setNewPw(''); setNewPw2('');
        } catch (e) {
            setMsg({ color: 'danger', text: e?.response?.data?.error || 'Ошибка смены пароля' });
        } finally { setLoading(false); }
    };

    return (
        <Stack spacing={2}>
            <Card variant="outlined" sx={{ p: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                    <LockRoundedIcon color="primary" />
                    <Typography level="title-md">Смена пароля</Typography>
                </Stack>
                <Typography level="body-sm" color="neutral" sx={{ mb: 2 }}>
                    Используйте этот раздел, чтобы заменить текущий пароль. Если вы его не помните — выйдите
                    и воспользуйтесь восстановлением по email.
                </Typography>

                {msg && <Alert color={msg.color} sx={{ mb: 1.5 }}>{msg.text}</Alert>}

                <Stack spacing={1.5} sx={{ maxWidth: 420 }}>
                    <FormControl>
                        <FormLabel>Текущий пароль</FormLabel>
                        <Input
                            type={showOld ? 'text' : 'password'}
                            value={oldPw}
                            onChange={e => setOldPw(e.target.value)}
                            endDecorator={
                                <IconButton variant="plain" size="sm" onClick={() => setShowOld(s => !s)}>
                                    {showOld ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
                                </IconButton>
                            }
                            autoComplete="current-password"
                        />
                    </FormControl>

                    <Divider sx={{ my: 0.5 }} />

                    <FormControl>
                        <FormLabel>Новый пароль</FormLabel>
                        <Input
                            type={showNew ? 'text' : 'password'}
                            value={newPw}
                            onChange={e => setNewPw(e.target.value)}
                            placeholder="не короче 8 символов"
                            endDecorator={
                                <IconButton variant="plain" size="sm" onClick={() => setShowNew(s => !s)}>
                                    {showNew ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
                                </IconButton>
                            }
                            autoComplete="new-password"
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Повторите новый пароль</FormLabel>
                        <Input
                            type={showNew ? 'text' : 'password'}
                            value={newPw2}
                            onChange={e => setNewPw2(e.target.value)}
                            autoComplete="new-password"
                            onKeyDown={e => e.key === 'Enter' && submit()}
                        />
                    </FormControl>

                    <Button
                        startDecorator={<SaveRoundedIcon />}
                        sx={{ alignSelf: 'flex-start', mt: 1 }}
                        loading={loading}
                        onClick={submit}
                        disabled={!oldPw || !newPw || !newPw2}
                    >
                        Сохранить пароль
                    </Button>
                </Stack>
            </Card>
        </Stack>
    );
}